import {
  AssembleiaPautaStatus,
  AssembleiaPautaStatusString,
} from 'helpers/enums/AssembleiaPautaStatus';
import {
  AssembleiaStatus,
  StatusMensagens,
} from 'helpers/enums/AssembleiaStatus';
import {
  WSAssembleiasActionTypes,
  WS_ASSEMBLEIAS_ACTIONS_CLOSE,
  WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH,
  WS_ASSEMBLEIAS_ACTIONS_ON_ERROR,
  WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE,
  WS_ASSEMBLEIAS_ACTIONS_OPEN,
} from 'store/modules/WSAssembleiasActionTypes';
import { IAssembleiaAssociadoPautaVoto } from './AssembleiasAssociadoReducer';
import { WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE } from './WSAssembleiasActions';

export interface Messenger {
  flgPublica: boolean;
  cpf: string;
  idDuvidaFrequente: number;
  duvida: string;
  resposta: string;
  dataPergunta: string;
  flgDestaque: boolean;
  nomePessoaComentario: string;
}

export interface IWSPauta {
  idPauta: number;
  status: AssembleiaPautaStatus | null;
  statusPresencial: AssembleiaPautaStatusString | null;
  tempoVotacao: number | null;
  tempoRestante: number | null;
  resultadoLiberado: boolean | null;
  resultadoLiberadoAssociado: boolean | null;
  resultadoLiberadoPresencial?: boolean;
  votos?: IAssembleiaAssociadoPautaVoto[];
}

export interface IWSAssembleia {
  id: number;
  idPauta?: number;
  needLoadPautas?: boolean;
  needLoadContas?: boolean;
  statusChat: StatusMensagens;
  pautas: IWSPauta[];
  usuariosLogados: number | null;
  presentes: number;
  status: AssembleiaStatus;
  messenger?: Messenger | null;
  contasCapital?: number;
  needLoadQuorum: boolean | null;
  data: string | null;
  titulo: string | null;
  urlTransmissao: string | null;
}

export interface IWSAssembleiasReducer {
  opened: boolean;
  error: any;
  assembleiasChanges: {
    [key: number]: IWSAssembleia;
  };
  usuariosLogados: number;
}

const INITIAL_STATE: IWSAssembleiasReducer = {
  opened: false,
  error: null,
  assembleiasChanges: {},
  usuariosLogados: WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE,
};

export default function WSAssembleiasReducer(
  state: IWSAssembleiasReducer = INITIAL_STATE,
  action: WSAssembleiasActionTypes
): IWSAssembleiasReducer {
  switch (action.type) {
    case WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH:
      return {
        ...state,
      };
    case WS_ASSEMBLEIAS_ACTIONS_OPEN:
      return {
        ...state,
        opened: true,
        error: INITIAL_STATE.error,
      };
    case WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE:
      return {
        ...state,
        usuariosLogados:
          typeof action.payload.usuariosLogados === 'number'
            ? action.payload.usuariosLogados
            : state.usuariosLogados,
        assembleiasChanges: {
          ...state.assembleiasChanges,
          [action.payload.id]: action.payload,
        },
      };
    case WS_ASSEMBLEIAS_ACTIONS_CLOSE:
      return {
        ...state,
        opened: INITIAL_STATE.opened,
        error: INITIAL_STATE.error,
      };
    case WS_ASSEMBLEIAS_ACTIONS_ON_ERROR:
      return {
        ...state,
        opened: INITIAL_STATE.opened,
        error: action.payload,
      };
    default:
      return state;
  }
}
